import ControlArea from "components/Layout/control-area";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { getAllApplications, getAllWebhooks } from "store/actions";
import Icon from "./assets/binocular.svg";
import BootyPagination from "components/shared/pagination";
import { useParams, useSearchParams } from "react-router-dom";
import EditAlertsSwitch from "./EditAlertsSwitch";
import { handleErrMsg } from "helpers/functions";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import TableControl from "components/shared/table";
import { getId } from "helpers/functions";

const Webhooks = () => {
    const { webhooks, loading, error } = useSelector((state) => state.webhooks);
    const {
        applications,
        loading: appsLoading,
        error: appsError,
    } = useSelector((state) => state.applications);
    const dispatch = useDispatch();
    const { formatMessage, locale } = useIntl();
    const [isDispatched, setIsDispatched] = useState(false);
    const [searchParams] = useSearchParams();
    const { applicationId } = useParams();
    useEffect(() => {
        setIsDispatched(true);
        dispatch(getAllWebhooks({ applicationId }));
        if (!applications?.length > 0) dispatch(getAllApplications());
    }, [dispatch, searchParams]);

    // error
    useEffect(() => {
        if ((error || appsError) && isDispatched) {
            toastErrorMessage(
                formatMessage({ id: handleErrMsg(error || appsError) }),
                locale
            );
        }
    }, [error, appsError, formatMessage, locale, isDispatched]);

    const columns = [
        {
            name: <FormattedMessage id="appName" />,
            selector: (row) =>
                applications?.find((app) => getId(app) == row?.applicationId)
                    ?.name?.[locale],
            sortable: true,
        },
        {
            name: <FormattedMessage id="eventKey" />,
            selector: (row) => row?.eventKey,
            sortable: true,
        },
        {
            name: <FormattedMessage id="eventType" />,
            selector: (row) => row?.eventType,
            sortable: true,
        },
        {
            name: <FormattedMessage id="status" />,
            selector: (row) => <FormattedMessage id={row?.status} />,
            sortable: true,
        },
    ];
    return (
        <div className="applications-wrap">
            <ControlArea
                cardTxt={<FormattedMessage id="webhooks" />}
                icon={Icon}
            />
            <EditAlertsSwitch />
            <TableControl
                title={"webhooksTableShowAll"}
                columns={columns}
                data={webhooks}
                loading={loading || appsLoading}
            />
            <BootyPagination metaData={webhooks?.metadata} />
        </div>
    );
};

export default Webhooks;
